import { call, put, takeLatest } from "redux-saga/effects";

import { PatientsAPI } from "../../../api/patientsAPI";
import {
  GET_PATIENT_WALKING_ASYMMETRY_REQUEST,
  GET_PATIENT_WALKING_ASYMMETRY_ERROR,
  GET_PATIENT_WALKING_ASYMMETRY_SUCCESS,
} from "../../actions";

function* workerGetPatientWalkingAsymmetrySaga({
  type,
  payload: { patientId, startDate, endDate },
}: {
  type: string;
  payload: {
    patientId: any;
    startDate: string;
    endDate: string;
  };
}): Generator<any> {
  try {
    const data: any = yield call(PatientsAPI.getPatientAsymmetry, {patientId, from: startDate, to: endDate});

    yield put({
      type: GET_PATIENT_WALKING_ASYMMETRY_SUCCESS,
      payload: { asymmetry: data }
    });
  } catch (error: any) {
    yield put({
      type: GET_PATIENT_WALKING_ASYMMETRY_ERROR,
      payload: { code: error.response.status, message: error.message }
    });
  }
}

export function* watcherGetPatientWalkingAsymmetrySaga() {
  yield takeLatest(GET_PATIENT_WALKING_ASYMMETRY_REQUEST, workerGetPatientWalkingAsymmetrySaga);
}
